import type { WorkfrontConfig } from '@wf-coe/types';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

/** Wire-format Workfront config — Date fields are ISO strings. */
export type WorkfrontConfigDto = Omit<WorkfrontConfig, 'createdAt' | 'updatedAt'> & {
  createdAt: string;
  updatedAt: string;
};

/**
 * Lists Workfront configs for a tenant. Disabled until both an api
 * client (signed-in MSAL account) and a `clientId` are available.
 */
export function useWorkfrontConfigsQuery(
  clientId: string | undefined,
): UseQueryResult<WorkfrontConfigDto[]> {
  const api = useApiClient();
  return useQuery({
    queryKey: ['workfront-configs', clientId],
    queryFn: () => {
      if (!api) throw new Error('useWorkfrontConfigsQuery: api client unavailable');
      if (!clientId) throw new Error('useWorkfrontConfigsQuery: clientId required');
      return api.get<WorkfrontConfigDto[]>(`/v1/clients/${clientId}/workfront-configs`);
    },
    enabled: api !== undefined && clientId !== undefined,
  });
}
